import React, { useState, useEffect, Fragment } from "react";
import { useHistory } from "react-router-dom";
import {
	API_URL,
	scroll,
	getValFromLS,
	setValToLS,
	isFieldError,
} from "../helpers";
import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Input from "../components/Input";
import Select from "../components/Select";
import Textarea from "../components/Textarea";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

const CharityRegPromote = () => {
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({
		id: "0",
	});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const history = useHistory();

	useEffect(() => {
		scroll();
		init(getValFromLS("crId") || "0");
	}, []);

	const init = async (id) => {
		const url = new URL(`${API_URL}/crPromoteInit`);
		const params = {
			id,
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json) {
				setNames({ ...json });
				setAlert({});
				if (json.resp === 0 && getValFromLS("crId")) {
					setValToLS("crId", "");
				}
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/crPromote`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			data.append(key, value);
		});

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setValToLS("crId", json.id);
				history.push("/registration");
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<div id="full-column">
			<Hdg section="Registration" />
			<Fragment>
				{alert.type ? (
					<Alert data={alert} />
				) : (
					<Fragment>
						<h3>
							<i className="fa fa-file-text-o" /> &nbsp;Fundraising Information
						</h3>
						<p>
							Please fill out this form completely so we can know how to better
							promote your organization throughout the year on social media, in
							our e-newsletter, on TV interviews, etc. Should you have any
							questions, please contact{" "}
							<a href="mailto:stephanie@valerotexasopen.com">
								Stephanie@ValeroTexasOpen.com
							</a>{" "}
							or at 210.345.3839.
						</p>

						<form
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							className="well"
						>
							<div className="form-group">
								<Textarea
									name="mission"
									label="Charity Mission"
									reqd={true}
									value={names.mission || ""}
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="goal"
									label="Fundraising Goal for 2026-2027 Campaign ($)"
									reqd={true}
									value={names.goal || ""}
									update={handleUpdate}
									errors={errors}
								/>
							</div>
							<div className="form-group">
								<Input
									name="utilized"
									label="How will the funds be utilized?"
									reqd={true}
									value={names.utilized || ""}
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="impacted"
									label="How many will be impacted?"
									reqd={true}
									value={names.impacted || ""}
									update={handleUpdate}
									errors={errors}
								/>
							</div>
							<div className="form-group one">
								<Textarea
									name="fundsUsed"
									label="If you participated in the last campaign, how were the funds used and feel free to share an interesting story of how it impacted someone."
									reqd={false}
									value={names.fundsUsed || ""}
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<div className="form-group">
								<Select
									name="pillar"
									label="Which Valero “giving pillar” best represents how the funds raised through Champions fore Charity will be utilized?"
									reqd={true}
									value={names.pillar || ""}
									options={[
										{ id: "", name: "--" },
										{ id: "Basic Needs", name: "Basic Needs" },
										{ id: "Education", name: "Education" },
										{ id: "Healthcare", name: "Healthcare" },
									]}
									update={handleUpdate}
									error={isFieldError(errors, "pillar")}
								/>
								<div className="empty" />
							</div>

							<div className="msg-submit">
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" || msg.type === "success"
											? "hidden"
											: "submit-container"
									}
								>
									<Submit
										path="/registration"
										left="Back"
										submit="Submit Fundraising Information"
									/>
								</div>
							</div>
						</form>
					</Fragment>
				)}
			</Fragment>
		</div>
	);
};

export default CharityRegPromote;
